import {Observable} from 'rxjs';
import {AppComponent} from './app.component';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
//import 'rxjs/Rx';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {FormControl, Validators} from "@angular/forms";
import {ComboAllType} from "./model/app/ComboAllType";
import {SelectItem} from "./model/db/pojo/common/SelectItem";
import {InputFieldOptions} from "../../main/src/model/app/Decorators";


export class UIHelper {

    public static status = false;
    public static appendHeader = null;

    public static doGetJSON(http: HttpClient, app: AppComponent, path, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("get", http, app, path, null, resultIsJSON, true, returnFullResponse, ownErrorHandling);
    }

    public static doPostJSON(http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("post", http, app, path, content, resultIsJSON, true, returnFullResponse, ownErrorHandling);
    }

    public static doPost(http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("post", http, app, path, content, resultIsJSON, false, returnFullResponse, ownErrorHandling);
    }

    public static doPutJSON(http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("put", http, app, path, content, resultIsJSON, true, returnFullResponse, ownErrorHandling);
    }

    public static doPut(http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("put", http, app, path, content, resultIsJSON, false, returnFullResponse, ownErrorHandling);
    }

    public static doDeleteJSON(http: HttpClient, app: AppComponent, path, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest("delete", http, app, path, null, resultIsJSON, true, returnFullResponse, ownErrorHandling);
    }

    public static doPostPut(mode: string, http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        UIHelper.status = true;
        return UIHelper.doRequest(mode.toLowerCase(), http, app, path, content, resultIsJSON, false, returnFullResponse, ownErrorHandling);
    }

    private static doRequest(type: string, http: HttpClient, app: AppComponent, path, content, resultIsJSON = true, sendDataJSON = true, returnFullResponse = false, ownErrorHandling = false): Observable<any> {
        let appendHeaders = {};

        appendHeaders['Content-Type'] = 'application/json';
        if (this.appendHeader !== null) {
            for (let itemKey in this.appendHeader) {
                appendHeaders[itemKey] = this.appendHeader[itemKey];
            }
        }
        var headers = new HttpHeaders(appendHeaders);
        //headers.append('appWindowUUID', windowUUID);
        //var headers = new HttpHeaders();

        let urlHash = window.location.hash;
        if (urlHash.indexOf("#") === 0) {
            urlHash = urlHash.substring(1);
            if (urlHash.indexOf(";") !== -1) {
                let urlHashArray = urlHash.split(";");
                urlHash = urlHashArray[0];
            }
        }

        if (app.lastHttpUrl !== urlHash) {
            //if (app.lastHttpUrl !== '') {
            //headers.append('appWindowDV', 'ALL');
            //}
            app.lastHttpUrl = urlHash;
        }

        let result: any;
        let urlPath = path;
        if ((urlPath.indexOf('http') !== 0) && (urlPath.indexOf('https') !== 0)) {
            urlPath = getContextPath() + path;
        }

        let options = {};
        options['headers'] = headers;
        if (!resultIsJSON) {
            options['responseType'] = 'blob';
        }
        if (returnFullResponse) {
            options['observe'] = 'response';
        }

        switch (type) {
            case 'get':
                /*
                 let appWindowUUID = "";
                 if (path.indexOf("?") === -1) {
                 appWindowUUID = "?" + windowUUID;
                 }
                 else {
                 appWindowUUID = "&" + windowUUID;
                 }*/
                result = http.get(urlPath/* + appWindowUUID*/, options);
                break;
            case 'post':
                //content['appWindowUUID'] = windowUUID;
                result = http.post(urlPath, sendDataJSON ? JSON.stringify(content) : content, options);
                break;
            case 'put':
                //content['appWindowUUID'] = windowUUID;
                result = http.put(urlPath, sendDataJSON ? JSON.stringify(content) : content, options);
                break;
            case 'delete':
                /*
                 if (path.indexOf("?") === -1) {
                 appWindowUUID = "?" + windowUUID;
                 }
                 else {
                 appWindowUUID = "&" + windowUUID;
                 }*/
                result = http.delete(urlPath/* + appWindowUUID*/, options);
                break;
        }

        let shareable = result.share();

        shareable.subscribe(
            resultFullData => {
                let resultData = null;
                if (returnFullResponse) {
                    resultData = resultFullData.body;
                } else {
                    resultData = resultFullData;
                }
                UIHelper.status = false;
                if (typeof resultData.result !== 'undefined' && typeof resultData.result.resultStatus !== 'undefined') {
                    if (resultData.result.resultStatus == 'AUTHENTICATION_FAILURE') {
                        window.location.href = getContextPath() + '/';
                    } else if (resultData.result.resultStatus == 'AUTHORIZATION_FAILURE') {
                        alert(resultData.result.message);
                        return;
                    } else if (resultData.result.resultStatus == 'REDIRECT') {
                        disableUser();
                        //alert(getContextPath() + resultData.result.resultMessage);
                        window.location.href = getContextPath() + resultData.result.resultMessage;
                        return;
                    }
                    if (!ownErrorHandling && resultData.result.resultStatus == 'OK' && typeof resultData.result.resultMessage !== 'undefined') {
                        app.addGrowlInfoMessage(resultData.result.resultMessage);
                    }
                    if (typeof resultData.result.growlMessages !== 'undefined') {
                        for (var i = 0; i < resultData.result.growlMessages.length; i++) {
                            var growlMessage = resultData.result.growlMessages[i];
                            app.addGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                        }
                    }
                    if (typeof resultData.result.stickyGrowlMessages !== 'undefined') {
                        for (var i = 0; i < resultData.result.stickyGrowlMessages.length; i++) {
                            var growlMessage = resultData.result.stickyGrowlMessages[i];
                            app.addStickyGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                        }
                    }
                }
            },
            error => {
                UIHelper.status = false;
                if (ownErrorHandling) {
                    return;
                }
                try {
                    if (error.status == 401) {
                        window.location.hash = '';
                        window.location.href = getContextPath() + '/';
                        return;
                    }
                    if (error.status == 404) {
                        app.addGrowlErrorMessage('Error', 'Url not found. Please try again.');
                        enableUser();
                        return;
                    }

                    if (UIHelper.showResultMessageIfError(app, error)) {
                        error.ok = true;
                        enableUser();
                        return;
                    }

                } catch (e) {
                }
                UIHelper.status = false;
                app.addStickyGrowlMessage('error', 'Ismeretlen hiba', 'Kérem próbálja a műveletet újra.');
                enableUser();
            }
        );
        //return shareable;
        return shareable;
    }

    public static showResultMessageIfError(app, error) {
        try {
            let messageSended = false;
            if (error.error.result.resultStatus == 'NOTOK' && typeof error.error.result.resultMessage !== 'undefined' && error.error.result.resultMessage != '') {
                app.addGrowlErrorMessage(error.error.result.resultMessage);
            }
            if (typeof error.error.result.growlMessages !== 'undefined') {
                for (var i = 0; i < error.error.result.growlMessages.length; i++) {
                    var growlMessage = error.error.result.growlMessages[i];
                    app.addGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                }
                messageSended = true;
            }
            if (typeof error.error.result.stickyGrowlMessages !== 'undefined') {
                for (var i = 0; i < error.error.result.stickyGrowlMessages.length; i++) {
                    var growlMessage = error.error.result.stickyGrowlMessages[i];
                    app.addStickyGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
                }
                messageSended = true;
            }
            return messageSended;
        } catch (e) {
        }
        return false;
    }

    public static parseJSONMessages(app: AppComponent, data: any) {
        if (typeof data.result.growlMessages !== 'undefined') {
            for (var i = 0; i < data.result.growlMessages.length; i++) {
                var growlMessage = data.result.growlMessages[i];
                app.addGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
            }
        }
        if (typeof data.result.stickyGrowlMessages !== 'undefined') {
            for (var i = 0; i < data.result.stickyGrowlMessages.length; i++) {
                var growlMessage = data.result.stickyGrowlMessages[i];
                app.addStickyGrowlMessage(growlMessage.type, growlMessage.summary, growlMessage.detail);
            }
        }
    }

    public static bootstrapLoadJSON(callback) {
        var xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open('GET', getContextPath() + '/admin/populate', true);
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == 200) {
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }

    public static cloneObject<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    public static shallowCloneObject<T>(obj: T): T {
        /*if ($.isArray(obj)) {
         result =
         for (let item of obj)
         return $.extend(true, [], obj);
         } else {
         return $.extend(true, {}, obj);
         }
         */
        //return $.extend({}, obj);
        const gdcc = "__getDeepCircularCopy__";
        if (obj !== Object(obj)) {
            return obj; // primitive value
        }

        var set = gdcc in obj,
            cache = obj[gdcc],
            result;
        if (set && typeof cache == "function") {
            return cache();
        }
        // else
        obj[gdcc] = function () {
            return result;
        }; // overwrite
        if (obj instanceof Array) {
            result = [];
            for (var i = 0; i < obj.length; i++) {
                result[i] = this.shallowCloneObject(obj[i]);
            }
        } else {
            result = {};
            for (var prop in obj) {
                if (prop != gdcc && typeof obj[prop] === 'function') {
                    result[prop] = obj[prop];
                    //console.log(obj[prop]);
                    //console.log(result[prop]);
                } else {
                    // console.log(prop + ': ' + typeof obj[prop]);
                    if (prop != gdcc)
                        result[prop] = this.shallowCloneObject(obj[prop]);
                    else if (set)
                        result[prop] = this.shallowCloneObject(cache);
                }
            }
        }
        if (set) {
            obj[gdcc] = cache; // reset
        } else {
            delete obj[gdcc]; // unset again
        }
        return result;
    }

    public static getComboboxFirstValue(comboValues: any): any {
        if (comboValues.length > 0) {
            return comboValues[0].value;
        }

        return null;
    }

    public static setComboSelectItemSafeValue(controlType: string, value: any, options: any[]): any {
        let found = false;

        for (let option of options) {
            if (option.value === value) {
                found = true;
            }
        }
        if (!found) {
            if (controlType !== 'multi-select') {
                value = UIHelper.getComboboxFirstValue(options);
            } else {
                value = [];
            }
        }

        return value;
    }

    public static ltrim(char, str) {
        if (str.slice(0, char.length) === char) {
            return UIHelper.ltrim(char, str.slice(char.length));
        } else {
            return str;
        }
    }

    public static rtrim(char, str) {
        if (str.slice(str.length - char.length) === char) {
            return UIHelper.rtrim(char, str.slice(0, 0 - char.length));
        } else {
            return str;
        }
    }

    public static addEllipse(selector: string) {
        $(selector).each(function () {
            let isEllipse = $(this).data('isEllipse');
            if (typeof isEllipse !== 'undefined' && isEllipse === '1') {
                $(this).attr('title', '');
            }
            if ($(this).outerWidth() < $(this)[0].scrollWidth) {
                $(this).attr('title', $(this).text());
                $(this).data('isEllipse', '1');
            }
        });
    }

    public static getFileNameFromHttpResponse(httpHeaders: HttpHeaders) {
        var contentDispositionHeader = httpHeaders.get('Content-Disposition');
        var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
    }

    public static getCombolistWithAll(comboValuesOriginal: any, mode: number): any {
        let comboValues = UIHelper.cloneObject(comboValuesOriginal);

        if (mode === ComboAllType.MixedAll || mode === ComboAllType.MixedNone || mode === ComboAllType.NullMixedNone) {
            let noneOfThemItem = new SelectItem();
            noneOfThemItem.value = -1;
            noneOfThemItem.label = "Egyik sem";
            comboValues.unshift(noneOfThemItem);
        }

        let allValueItem = new SelectItem();

        switch (mode) {
            case ComboAllType.All:
                allValueItem.value = 0;
                allValueItem.label = "Összes";
                break;
            case ComboAllType.NullAll:
                allValueItem.value = null;
                allValueItem.label = "Összes";
                break;
            case ComboAllType.NoneOfThem:
                allValueItem.value = 0;
                allValueItem.label = "Egyik sem";
                break;
            case ComboAllType.NullNoneOfThem:
                allValueItem.value = null;
                allValueItem.label = "Egyik sem";
                break;
            case ComboAllType.None:
                allValueItem.value = 0;
                allValueItem.label = "-";
                break;
            case ComboAllType.NullNone:
                allValueItem.value = null;
                allValueItem.label = "-";
                break;
            case ComboAllType.MixedAll:
                allValueItem.value = 0;
                allValueItem.label = "Összes";
                break;
            case ComboAllType.NullMixedAll:
                allValueItem.value = null;
                allValueItem.label = "Összes";
                break;
            case ComboAllType.MixedNone:
                allValueItem.value = 0;
                allValueItem.label = "-";
                break;
            case ComboAllType.NullMixedNone:
                allValueItem.value = null;
                allValueItem.label = "-";
                break;
        }
        comboValues.unshift(allValueItem);

        return comboValues;
    }

    public static populateFormGroup(inputFields: InputFieldOptions[], formItems: any) {
        if (typeof formItems == 'undefined' || formItems == null) {
            formItems = {};
        }
        for (let itemKey in inputFields) {
            let item = inputFields[itemKey];
            if (item.type == null) {
                formItems[itemKey] = item.required ? new FormControl('', Validators.required)
                    : new FormControl('')
            } else {
                if (item.type == 'float') {
                    formItems[itemKey] = item.required ? new FormControl('', Validators.compose([Validators.required, AppComponent.instance.appValidator.isFloat]))
                        : new FormControl('')
                }
                if (item.type == 'integer') {
                    formItems[itemKey] = item.required ? new FormControl('', Validators.compose([Validators.required, AppComponent.instance.appValidator.isInt]))
                        : new FormControl('')
                }
                if (item.type == 'email') {
                    formItems[itemKey] = item.required ? new FormControl('', Validators.compose([Validators.required, AppComponent.instance.appValidator.isEmail]))
                        : new FormControl('')
                }
            }
        }
    }

}
